import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';
import { NewsArticle } from '../../Models/News/News';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { takeUntil, finalize } from 'rxjs';
import { BaseComponent } from '../../Base/base/base.component';

@Component({
  selector: 'app-new-providers',
  templateUrl: './new-providers.component.html',
  styleUrls: ['./new-providers.component.css'],standalone:false
})
export class NewProvidersComponent  extends BaseComponent{
  //declarations
  loading:boolean=false;
  news:NewsArticle[]=[];
  itemId!:string
  providername:string='France 24'
  logoprovider:string='https://www.france24.com/favicon.ico'
  pageNum:number=1;
  pageSize:number=10;
  totalRecords: number = 0;
  userRole:string=''
  //Initilization
  constructor
  (
       private api:BaseApiService,
       private messageService:MessageService,
       private route: ActivatedRoute,
       private sanitizer: DomSanitizer,
       private auth :AuthService
  )
  {
     super();
       this.userRole=this.auth.getRoles().toString();
  }

  //Getting news
  GetNotifications(id:string,pageNum:number,pageSize:number)
  {
    this.loading=true;
    this.api.read(`WebScrapper/get-feed?feedUrl=${id}&pageNum=${pageNum}&pageSize=${pageSize}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.news     = response;
          this.loading  = false;
        }
        ,
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
  }

  nextPage(): void {
    this.pageNum++;
    this.GetNotifications(this.itemId,this.pageNum,this.pageSize);
  }

  previousPage(): void {
    if (this.pageNum > 1) {
      this.pageNum--;
      this.GetNotifications(this.itemId,this.pageNum,this.pageSize);
    }
  }



  getLogo(url:string)
  {
     const con = this.api.getNewsProviderDetails(url)
     if(con){
       this.logoprovider=con.logoUrl;
       return this.logoprovider;
     }
     return this.logoprovider;
  }

  sanitizeHtml(htmlContent: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  sanitizeHtmlWithImageFix(html: string) {
    // Create a temporary DOM element to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    // Select the first image element if it exists
    const images = tempDiv.querySelectorAll('img');
    let imageSrc = '';

    if (images.length > 0) {
      // Get the src of the first image
      imageSrc = images[0].src;

      // Remove the image from the description
      images[0].remove();
    }

    // Style remaining images (if any)
    images.forEach((img: HTMLImageElement) => {
      img.style.width = '100%';    // Make the image responsive
      img.style.height = 'auto';   // Maintain aspect ratio
      img.classList.add('rounded-2', 'shadow'); // Optional: Apply additional styling
    });

    // Return both sanitized HTML and image source
    return {
      sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML),
      imageSrc: imageSrc
    };
  }


  getFaviconUrl(rssUrl: string): string {
    try {

      const url    = new URL(rssUrl);
      const domain = url.origin;
      return `${domain}/favicon.ico`;

    } catch (error)
    {
      return 'assets/icons/default-favicon.png';
    }
  }


  getSiteName(url: string): string {
    try {
      // Create a URL object from the provided URL
      const urlObj = new URL(url);

      // Get the hostname (e.g., www.bfmtv.com)
      let hostname = urlObj.hostname;

      // Remove common subdomains like 'www.'
      if (hostname.startsWith('www.')) {
        hostname = hostname.replace('www.', '');
      }

      // Capitalize the first letter of each word to create a clean name
      const siteName = hostname.split('.')[0]; // Take the main part of the domain
      return this.capitalizeWords(siteName); // Capitalize the first letter of the name
    } catch (error) {
      // In case of error, return a default name or an empty string
      return 'Unknown Site';
    }
  }

  // Helper function to capitalize words
  private capitalizeWords(name: string): string {
    return name.charAt(0).toUpperCase() + name.slice(1);
  }

  //Calling
  ngOnInit(): void
  {

    this.route.params.subscribe(params => {
      this.itemId = params['id'];
      if(this.itemId!=null){
        this.providername=this.itemId;
        this.GetNotifications(this.itemId,this.pageNum,this.pageSize);
      }
    });
  }

}
